import { Component, Input } from '@angular/core';
import { SharedModule } from '../../ui-components/shared.module';

@Component({
  selector: 'vw-img',
  imports: [
    SharedModule,
  ],
  templateUrl: './img.component.html',
  styleUrl: './img.component.scss'
})
export class ImgComponent {
  @Input() src: string;
  @Input() rounded?: boolean;
  @Input() backgroundColor: string = null;
}
